import React from 'react';
import { NavMenuItem } from './models/navMenuItem';
import PeopleIcon from '@mui/icons-material/People';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SettingsIcon from '@mui/icons-material/Settings';
import WarningIcon from '@mui/icons-material/Warning';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import DeviceHub from '@mui/icons-material/DeviceHub';
import BusinessIcon from '@mui/icons-material/Business';
import BoltIcon from '@mui/icons-material/Bolt';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ReplyIcon from '@mui/icons-material/Reply';
import CampaignIcon from '@mui/icons-material/Campaign';

// import DashboardIcon from '@mui/icons-material/Dashboard';
// import HelpIcon from '@mui/icons-material/Help';
// import SourceIcon from '@mui/icons-material/Source';
//import LayersIcon from '@mui/icons-material/Layers';

// Custom SVG icon for contracts - document with seal
const ContractIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    style={{ display: 'block' }}
  >
    {/* Document base */}
    <rect
      x="3"
      y="2"
      width="18"
      height="20"
      rx="1"
      fill="white"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    {/* Document lines */}
    <line x1="6" y1="6" x2="18" y2="6" stroke="currentColor" strokeWidth="1" />
    <line x1="6" y1="9" x2="18" y2="9" stroke="currentColor" strokeWidth="1" />
    <line
      x1="6"
      y1="12"
      x2="18"
      y2="12"
      stroke="currentColor"
      strokeWidth="1"
    />
    <line
      x1="6"
      y1="15"
      x2="14"
      y2="15"
      stroke="currentColor"
      strokeWidth="1"
    />
    {/* Seal/Ribbon in bottom right */}
    <circle
      cx="18"
      cy="18"
      r="3"
      fill="#d32f2f"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path d="M16.5 18 L19.5 18 L18 16.5 Z" fill="white" />
    <path d="M16.5 18 L19.5 18 L18 19.5 Z" fill="white" />
  </svg>
);

export const primaryNavItems: NavMenuItem[] = [
  {
    icon: <BusinessIcon />,
    label: 'Organizations',
    path: 'organizations',
    indexType: 'Organization',
    ariaLabel: 'organizations page',
  },
  {
    icon: <ApartmentIcon />,
    label: 'Properties',
    path: 'properties',
    ariaLabel: 'properties page',
  },
  {
    icon: <PeopleIcon />,
    label: 'Users',
    path: 'users',
    indexType: 'User',
    ariaLabel: 'users page',
  },
  {
    icon: <WarningIcon />,
    label: 'Alerts',
    path: 'alerts',
    indexType: 'Alert',
    ariaLabel: 'alerts page',
  },
  {
    icon: <CampaignIcon />,
    label: 'System Notifications',
    path: 'system-notifications',
    indexType: 'SystemNotification' as any,
    ariaLabel: 'system notifications page',
  },
  {
    icon: <DeviceHub />,
    label: 'Sources',
    path: 'sources',
    indexType: 'Source',
    ariaLabel: 'sources page',
  },
  {
    icon: <MiscellaneousServicesIcon />,
    label: 'Bulk Config',
    path: 'bulk-config',
    indexType: 'BulkConfig',
    ariaLabel: 'bulk configuration page',
  },
  {
    icon: <UploadFileIcon />,
    label: 'Provisioning',
    path: 'ingestions',
    indexType: 'Ingestion',
    ariaLabel: 'provisioning page',
  },
  {
    icon: <DisplaySettingsIcon />,
    label: 'Setpoint Profiles',
    path: 'setpoint-profiles',
    indexType: 'SetpointProfile',
    ariaLabel: 'setpoint profiles page',
  },
  {
    icon: <SettingsSuggestIcon />,
    label: 'Zone Policies',
    path: 'zone-policies',
    indexType: 'ZonePolicy',
    ariaLabel: 'zone policies page',
  },
  {
    icon: <ElectricalServicesIcon />,
    label: 'PLM Partners',
    path: 'plmPartners',
    indexType: 'PlmPartner',
    ariaLabel: 'PLM partners page',
  },
  {
    icon: <AssignmentIcon />,
    label: 'PLM Programs',
    path: 'plmPrograms',
    indexType: 'PlmProgram',
    ariaLabel: 'PLM programs page',
  },
  {
    icon: <ContractIcon />,
    label: 'PLM Contracts',
    path: 'plmContracts',
    indexType: 'PlmContract',
    ariaLabel: 'PLM contracts page',
  },
  {
    icon: <NotificationsIcon />,
    label: 'PLM Events',
    path: 'plm-events',
    indexType: 'PlmEvent',
    ariaLabel: 'PLM events page',
  },
  {
    icon: <ReplyIcon />,
    label: 'PLM Responses',
    path: 'plm-event-responses',
    indexType: 'PlmEventResponse',
    ariaLabel: 'PLM Responses page',
  },
  {
    icon: <BoltIcon />,
    label: 'Curtailment Plans',
    path: 'plmCurtailmentPlan',
    indexType: 'PlmCurtailmentPlan',
    ariaLabel: 'curtailment plans page',
  },
  {
    icon: <SettingsIcon />,
    label: 'Subscriptions',
    path: 'subscription-monitoring',
    indexType: 'SubscriptionMonitoring',
    ariaLabel: 'subscriptions page',
  },
  {
    icon: <AutoGraphIcon />,
    label: 'Real-time Testing',
    path: 'reports/real-time-testing',
    indexType: 'RealtimeTesting',
    ariaLabel: 'real-time testing report page',
  },
  {
    icon: <AutoGraphIcon />,
    label: 'Reports',
    path: 'reports',
    indexType: 'Reports',
    ariaLabel: 'reports page',
    children: [
      {
        icon: <WarningIcon />,
        label: 'Device Offline',
        path: 'reports/device-offline',
        indexType: 'Reports',
        ariaLabel: 'device offline report page',
      },
      {
        icon: <AssignmentIcon />,
        label: 'Quarterly Reports Data',
        path: 'reports/quarterly-reports-data',
        indexType: 'Reports',
        indexAction: 'extract_quarterly_data',
        ariaLabel: 'quarterly reports data page',
      },
    ],
  },
  // {
  //   icon: <DashboardIcon />,
  //   label: 'Dashboard',
  //   path: 'dashboard',
  //   indexType: 'Dashboard',
  //   ariaLabel: 'dashboard page',
  // },
  // {
  //   icon: <SettingsIcon />,
  //   label: 'Settings',
  //   path: 'settings',
  //   ariaLabel: 'settings page',
  // },
  // {
  //   icon: <HelpIcon />,
  //   label: 'Help',
  //   path: 'help',
  //   ariaLabel: 'help page',
  // },
  // {
  //   icon: <LayersIcon />,
  //   label: 'Unit Details',
  //   path: 'properties/:pid/units/:uid',
  //   ariaLabel: 'unit details page',
  // },
];

export const secondaryNavItems: NavMenuItem[] = [
  // {
  //   icon: <SourceIcon />,
  //   label: 'Year To Date',
  //   path: 'year-to-date',
  //   ariaLabel: 'year to date',
  // },
  // {
  //   icon: <SourceIcon />,
  //   label: 'Month To Date',
  //   path: 'month-to-date',
  //   ariaLabel: 'month to date',
  // },
  // {
  //   icon: <SourceIcon />,
  //   label: 'Previous Year',
  //   path: 'previous-year',
  //   ariaLabel: 'previous year',
  // },
];
